const identifierLength = 8;

let identifier: string;

let gtagId: string;

function initialize(length: number): string {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
}

export function getIdentifier(): string {
    if (!identifier) {
        identifier = initialize(identifierLength);
    }
    return identifier;
}

export function getGtagId(): string {
    if (typeof gtagId === 'undefined') {
        const ids = JSON.stringify(window.dataLayer).match(/G-[A-Z0-9]+/g);
        gtagId = ids?.[0] ?? '';
    }
    return gtagId;
}
